import { render, staticRenderFns } from "./YachtManufacturerRow.vue?vue&type=template&id=686b86e6&"
import script from "./YachtManufacturerRow.vue?vue&type=script&lang=js&"
export * from "./YachtManufacturerRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports